import { render, staticRenderFns } from "./RankChangeStudent.vue?vue&type=template&id=16b5805d&"
import script from "./RankChangeStudent.vue?vue&type=script&lang=js&"
export * from "./RankChangeStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports